import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Modal, Divider } from 'antd';
import SelectEdit from '../../components/SelectEdit';

import selector from './pressingEditor.selector';
import { setSelected } from '../Construction/construction.reducer';

import { availableType } from '../../types/available.types';
import { infoShape } from '../../types/info.types';

import {
  ModalContainer,
  StyledImg,
  ImgWrapper
} from './pressingEditor.styles';

class PressingEditor extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    setSelected: PropTypes.func.isRequired,
    available: PropTypes.arrayOf(availableType),
    info: infoShape,
    selected: PropTypes.number,
    walls_color_selected: PropTypes.number,
    colorsAvailableColors: PropTypes.object
  }

  static defaultProps = {
    available: [],
    selected: null,
    info: null,
    walls_color_selected: null,
    colorsAvailableColors: {}
  }

  state = {
    modalVisible: false
  }

  getAllowedPressingIds = () => {
    const colorId = this.props.walls_color_selected;
    if (!colorId) return null;

    const allowed = this.props.colorsAvailableColors?.[colorId];
    if (!Array.isArray(allowed)) return null;

    return allowed;
  };

  isPressingAvailable = (pressingId) => {
    const allowedPressingIds = this.getAllowedPressingIds();
    if (!allowedPressingIds) return true;

    return allowedPressingIds.includes(pressingId);
  };

  handleInsideChange = (value) => {
    if (!this.isPressingAvailable(value)) return;

    if (value !== this.props.selected) {
      this.props.setSelected('pressing', value);
      this.closeModal();
    }
  }

  openModal = () => {
    this.setState({ modalVisible: true });
  }

  closeModal = () => {
    this.setState({ modalVisible: false });
  }

  render() {
    return (
      this.props.loaded ? (
        <React.Fragment>
          <SelectEdit
            selected={this.props.selected}
            loaded={this.props.loaded}
            onEditClick={this.openModal}
            title={this.props.info.name}
            options={this.props.available.map((el) => ({
              id: el.id,
              value: `${el.attributes.value}`
            }))}
          />
          <Modal
            title={this.props.info.name}
            open={this.state.modalVisible}
            footer={null}
            onCancel={this.closeModal}
          >
            <ModalContainer>
              {
                this.props.available.map((el) => {
                  const isAvailable = this.isPressingAvailable(el.id);

                  return (
                    <div key={`inside__${el.attributes.value}`}>
                      <ImgWrapper
                        selected={el.id === this.props.selected}
                        onClick={isAvailable ? () => this.handleInsideChange(el.id) : () => {}}
                        style={{
                          opacity: isAvailable ? 1 : 0.45,
                          cursor: isAvailable ? 'pointer' : 'not-allowed'
                        }}
                      >
                        <StyledImg
                          src={el.attributes.img}
                          style={{
                            filter: isAvailable ? 'none' : 'grayscale(100%)'
                          }}
                        />
                      </ImgWrapper>
                      <p style={{ opacity: isAvailable ? 1 : 0.6 }}>
                        {el.attributes.value}
                      </p>
                    </div>
                  );
                })
              }
            </ModalContainer>
            <Divider>{this.props.info.info_title}</Divider>
            {this.props.info.info_content}
          </Modal>
        </React.Fragment>
      ) : <SelectEdit loading />
    );
  }
}

const mapDispatchToProps = {
  setSelected
};

export default connect(selector, mapDispatchToProps)(PressingEditor);
